module.exports = __webpack_public_path__ + "static/media/c36.e81f004a.png";